export const errorMessageFormSchema = {
  required: 'โปรดระบุข้อมูล',
  invalidEmail: 'โปรดกรอกอีเมลให้ถูกต้อง'
}

export const ERROR_MESSAGE = {
  REQUIRED_HAS_CHANGE_EMAIL_OR_MOBILE: 'โปรดอัพโหลดเอกสารการเปลี่ยนแปลงอีเมลหรือเบอร์โทร'
}
